import integrationsClient, { type ApiDefinition } from '@/tsClient/servers/integrationsService';
import buildPath from '@/tsClient/utilities/buildPath';

type THIS_API = ApiDefinition['/{provider}/creators/{creatorId}/account']['DELETE'];
type Input = THIS_API['params'] & THIS_API['query'];
type Output = THIS_API['response'];

const deleteCreatorIntegration = async ({ creatorId, email, provider }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>('/{provider}/creators/{creatorId}/account', { creatorId, provider });
  const response = await integrationsClient.delete(path, { params: { email } });
  return response.data;
};

export default deleteCreatorIntegration;
